import exponent from "./exponent";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/~/d3-format/src/precisionFixed.js
// module id = 981
// module chunks = 0